const sourceMapToken = process.env.SOURCE_MAP_TOKEN

document.cookie = sourceMapToken
  ? `sourceMapToken=${sourceMapToken}`
  : `sourceMapToken=${sourceMapToken};;;expires=Thu, 01 Jan 1970 00:00:01 GMT"`
